import { CalendarCheckIcon, CalendarXIcon, UserCirclePlusIcon } from '@phosphor-icons/react'
import { Badge } from 'app/components/ui/badge'
import { useCdtCodeMappings } from 'app/hooks/useCdtCodeMappings'
import { cn } from 'app/lib/utils'
import { TreatmentCard } from './treatmentFixture'
import { nextVisit, shortDate } from './treatmentDisplay'

/**
 * The facts about this case that change the conversation: an appointment that
 * broke means a reschedule, a visit already on the books means the open work
 * could ride along, and a patient nobody has seen yet means this is a
 * new-patient booking call, not treatment acceptance. Draws nothing when none
 * is true.
 */
export function ReasonBadge({ card, className }: { card: TreatmentCard; className?: string }) {
  const { categoryOf } = useCdtCodeMappings()
  const visit = nextVisit(card, categoryOf)
  // Strictly false: the staged fixture carries no `seen` and must not read as
  // a board of strangers.
  const unseen = card.seen === false
  if (!visit && card.column !== `broken` && !unseen) return null
  return (
    <div className={cn(`flex flex-wrap items-center gap-1.5`, className)}>
      {unseen && <Badge color="purple" icon={<UserCirclePlusIcon size={12} weight="fill" />} label="Never seen" />}
      {card.column === `broken` && (
        <Badge
          color="red"
          icon={<CalendarXIcon size={12} weight="fill" />}
          label={shortDate(card.brokenOn) ? `Broken ${shortDate(card.brokenOn)}` : `Broken appointment`}
        />
      )}
      {visit && (
        // Blue is treatment already on the books; grey is a cleaning, which
        // says they are reachable but none of this case is scheduled.
        <Badge
          color={visit.isTreatment ? `blue` : `gray`}
          icon={<CalendarCheckIcon size={12} weight="fill" />}
          label={shortDate(visit.on) ? `${visit.word} ${shortDate(visit.on)}` : visit.word}
        />
      )}
    </div>
  )
}
